// Analysis groups bank transaction timestamps by their stored UTC calendar
// date. Drill-downs must use the same dates, including the entire last day.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const transactionDayKey = value => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 10);
};
export const transactionMonthKey = value => {
  const key = transactionDayKey(value);
  return key ? `${MONTHS[Number(key.slice(5, 7)) - 1]}-${key.slice(2, 4)}` : '';
};
const rangeDayKey = value => {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};
export const isTransactionInDateRange = (transaction, range) => {
  if (!range?.startDate || !range?.endDate) return true;
  const day = transactionDayKey(transaction.date);
  return !!day && day >= rangeDayKey(range.startDate) && day <= rangeDayKey(range.endDate);
};
export const reportCategoryId = (transaction, categories) => {
  const id = transaction.category?.trim();
  return id && categories.some(c => c.id === id) ? id : 'uncategorized';
};
export const reportTransactionType = (transaction, categories) => {
  const category = categories.find(c => c.id === reportCategoryId(transaction, categories));
  if (category?.isTransfer) return null;
  if (category?.type === 'Income' || category?.type === 'Expense') return category.type;
  return transaction.amount > 0 ? 'Income' : transaction.amount < 0 ? 'Expense' : null;
};
